import {
  TOGGLE_SPOT_MODAL,
  SET_PANEL_MODE,
  SET_CAME_FROM_TRADE,
  SET_ASSET_CHANGE_DISABLED,
  SET_TRANSFER_AMOUNT,
} from 'actionTypes/spot';
import createAction from 'helpers/createAction';
import { PanelMode } from 'reducers/spot';

const toggleSpotModal = createAction<boolean>(TOGGLE_SPOT_MODAL);
const setPanelMode = createAction<PanelMode>(SET_PANEL_MODE);
const setCameFromTrade = createAction<boolean>(SET_CAME_FROM_TRADE);
const setAssetChangeDisabled = createAction<boolean>(SET_ASSET_CHANGE_DISABLED);
const setTransferAmount = createAction<string>(SET_TRANSFER_AMOUNT);

export {
  toggleSpotModal,
  setPanelMode,
  setCameFromTrade,
  setAssetChangeDisabled,
  setTransferAmount,
};
